












































































































































import Vue from 'vue'

import { Credentials, params, Profile, types } from '@/components/registration/module/types.ts'

export default Vue.extend({
  computed: {
    currentUser(): Profile {
      return this.$store.getters.currentUser
    },
    isSignedIn(): boolean {
      return this.$store.getters.isSignedIn
    },
  },
  data(): { loginFailed: boolean; signInForm: Credentials } {
    return {
      loginFailed: false,
      signInForm: {
        login: '',
        password: '',
      },
    }
  },
  methods: {
    login() {
      this.loginFailed = false
      this.$store
        .dispatch({
          credentials: this.signInForm,
          type: types.actions.Login,
        })
        .then(({ user, token }) => {
          this.loginFailed = false
          if (user.is_patient_account) {
            this.$router.push({ name: 'home' })
          } else {
            this.$router.push({ name: 'admin.tasks' })
          }
        })
        .catch(reason => {
          const { error } = reason.response.data
          this.loginFailed = error
        })
    },
  },
})
